<script lang="ts">
	import type { User } from "luxedo-data"
	import type { BundledAccountData } from "luxedo-rpc/src/types/BundledTypes"
	import UsersTableEntry from "./UsersTableEntry.svelte"

	interface Props {
		users: Array<User | BundledAccountData>;
	}

	let { users }: Props = $props();
</script>

<table>
	<thead>
		<tr>
			<th> ID </th>
			<th> Name </th>
			<th> Email </th>
		</tr>
	</thead>
	<tbody>
		{#if users}
			{#each users as user}
				<UsersTableEntry {user} />
			{/each}
		{/if}
	</tbody>
</table>

<style>
	table {
		margin-top: 1rem;
	}

	thead th:first-of-type {
		padding-left: 0.5rem;
	}
</style>
